import {
  Box,
  Text,
  ListItem,
  OrderedList,
  UnorderedList
} from "@chakra-ui/react";
import { AssetImage } from "@mi/asset-react";
import { useTranslation } from "react-i18next";
export default function Detail() {
  // const fonts = "MiSans, miui, serif";
  const { t } = useTranslation();
  const insets = typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get("insets") : null;
  const pb = insets === "0" ? "0px" : "40px";
  return (
    <Box
      paddingX={{
        base: "24px",
        xxxs: "24px",
        tablet: "72px",
        desktop: "144px"
      }}
      paddingTop="12px"
      paddingBottom={pb}
      // fontFamily="inherit"
    >
      <Text size="big">{t("charge.title")}</Text>
      <Box>
        <Text size="md" marginTop="48px" marginBottom="12px">
          {t("charge.sub1.title")}
        </Text>
        <Text size="small">{t("charge.sub1.content1")}</Text>
        <Text size="content" marginBottom="12px">
          {t("charge.sub1.detail1")}
        </Text>
        <Box
          display="flex"
          justifyContent="center"
          bg="#F5F5F5"
          border="1px solid rgba(0,0,0,0.06)"
          borderRadius="16px"
          margin="12px auto"
          sx={{
            div: {
              width: "344px"
            }
          }}
        >
          <AssetImage
            path="battery-detail/Frame-charge2.svg"
            layout="intrinsic"
            width={344}
            alt=""
            height={298}
            placeholder="data:image/svg+xml;base64,UklGRo4AAABXRUJQVlA4WAoAAAAQAAAAEwAAEAAAQUxQSDkAAAARJyAWTPxZuyKYRkQEGooaSYr2EjCzCsABEvCva5YXAiL6PwHVJveFjR5UXO4KsI+7K+AFNnpS8QAAVlA4IC4AAADwAgCdASoUABEAPtFgqU+oJSOiKAgBABoJaQAASyecAAD+8TjCyx52MzhtwAAA"
          />
        </Box>
        <Text size="small">{t("charge.sub1.content2")}</Text>
        <Text size="content">{t("charge.sub1.detail2")}</Text>
        <Text size="content" marginY="12px">
          {t("charge.sub1.desc")}
        </Text>
        <Text size="small">{t("charge.sub1.content3")}</Text>
        <UnorderedList>
          <ListItem>
            <Text size="content"> {t("charge.sub1.detail3-1")}</Text>
          </ListItem>
          <ListItem>
            <Text size="content"> {t("charge.sub1.detail3-2")}</Text>
          </ListItem>
        </UnorderedList>
      </Box>
      <Box>
        <Text size="md" marginTop="48px" marginBottom="12px">
          {t("charge.sub2.title")}
        </Text>
        {[1, 2, 3, 4, 5].map(num => (
          <Box key={num}>
            <Text size="small">{t(`charge.sub2.content${num}`)}</Text>
            <Text size="content">{t(`charge.sub2.detail${num}`)}</Text>
          </Box>
        ))}
      </Box>
      <Box>
        <Text size="md" marginTop="48px" marginBottom="12px">
          {t("charge.sub3.title")}
        </Text>
        <Text size="small"> {t("charge.sub3.subtitle")}</Text>
        {[1, 2, 3, 4].map(num => (
          <Box key={num}>
            <Text size="small">{t(`charge.sub3.content${num}`)}</Text>
            <Text size="content">{t(`charge.sub3.detail${num}`)}</Text>
          </Box>
        ))}
      </Box>
      <Text size="content" marginTop="12px" paddingBottom="30px">
        {t("charge.summary")}
      </Text>
    </Box>
  );
}
